import {
    array,
    boolean,
    literal,
    nativeEnum,
    object,
    string,
    TypeOf,
    union,
} from 'zod';

import { Alignment, ModelImage, PageTemplate } from '../common';
import { AToZPageElement } from './a-to-z';
import { BannerPageElement } from './banner';
import { CarouselPageElement } from './carousel';
import { GridPageElement } from './grid';
import { QrCodePageElement } from './qr-code';
import { SwimlanePageElement } from './swimlane';
import { TextPageElement } from './text';
import { VideoCarouselPageElement } from './video-carousel';

/* ------------------------------- PageElement ------------------------------ */

export const PageElement = union([
    AToZPageElement,
    CarouselPageElement,
    GridPageElement,
    SwimlanePageElement,
    VideoCarouselPageElement,
    TextPageElement,
    QrCodePageElement,
    BannerPageElement,
]);

export type PageElement = TypeOf<typeof PageElement>;

/* ------------------------------- CommonPage ------------------------------- */

const CommonPage = object({
    description: object({
        value: string().default(''),
        alignment: nativeEnum(Alignment).optional(),
        visible: boolean().optional(),
    }),
    id: string(),
    image: ModelImage.optional(),
    name: object({
        value: string(),
        alignment: nativeEnum(Alignment).optional(),
        visible: boolean().optional(),
    }),
    reference: string(),
    template: nativeEnum(PageTemplate),
    ageRating: string().optional(),
});
export type CommonPage = TypeOf<typeof CommonPage>;

/* -------------------------------- FlexPage -------------------------------- */

export const FlexPage = CommonPage.extend({
    elements: array(PageElement),
    template: literal(PageTemplate.Flex),
});
export type FlexPage = TypeOf<typeof FlexPage>;

/* -------------------------------- InfoPage -------------------------------- */

export const InfoPage = CommonPage.extend({
    template: literal(PageTemplate.Info),
});
export type InfoPage = TypeOf<typeof InfoPage>;

/* ---------------------------------- Page ---------------------------------- */

export const Page = union([FlexPage, InfoPage]);
export type Page = TypeOf<typeof Page>;

/* --------------------------------- Export --------------------------------- */

export * from './a-to-z';
export * from './banner';
export * from './carousel';
export * from './grid';
export * from './qr-code';
export * from './swimlane';
export * from './text';
export * from './tile';
export * from './video-carousel';
